const mcuTatDashboardRoutes = [
    {
        path: '/mcu-tat-dashboard',
        name: 'mcuTatDashboard',
        component: () => import('@/modules/mcu_tat_dashboard/Dashboard.vue'),
        meta: {
            resource: 'tat-dashboard',
            action: 'view',
            layout: 'default',
            auth: true,
            title: 'MCU TAT Dashboard',
            breadcrumbs: [{ title: 'MCU TAT Dashboard', routeName: 'mcuTatDashboard' }]
        }
    }
]

export default mcuTatDashboardRoutes
